/**
 * 判断环境
 */
export const isAgentApp = (name, ua = navigator.userAgent.toLowerCase()) => {
  const agentMapSupported = new Map([
    ['wx', /micromessenger/i.test(ua)], // 微信环境
    ['mini', ua.includes('miniprogram')], // 微信小程序 比如webview中
    ['wxwork', /wxwork/i.test(ua)], // 企业微信环境
    ['dingtalk', ua.includes('dingtalk')], // 钉钉环境
    ['ios', /(iPhone|iPad|iPod|iOS)/i.test(ua)],
    ['android', /(Android|Adr)/i.test(ua)],
    ['mobile', /Android|webOS|iPhone|iPod|BlackBerry/i.test(ua)],
		['appx', /uni-app-x/i.test(ua)] // uni-app-x | 自营APP
  ])
  if (agentMapSupported.has(name)) return agentMapSupported.get(name)
  return false
}
